import { OPEN_ASIA_POPUP, SET_DESTINATION_URL, TOGGLE_ASIA_POPUP } from '../actions/asiaPopup';

const initialState = {
  isOpen: false,
  destinationUrl: null,
};

export default (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case TOGGLE_ASIA_POPUP:
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    case OPEN_ASIA_POPUP:
      return {
        ...state,
        isOpen: true,
      };
    case SET_DESTINATION_URL:
      return {
        ...state,
        destinationUrl: action.payload,
      };
    /* istanbul ignore next -- @preserve */
    default:
      return state;
  }
};
